/** `Blob.arrayBuffer` is missing in older engines and in jsdom, hence the reader fallback. */
export const bytesOf = async (blob: Blob): Promise<Uint8Array> => {
  if (typeof blob.arrayBuffer === "function") {
    return new Uint8Array(await blob.arrayBuffer())
  }
  return new Promise((resolve, reject) => {
    const reader = new FileReader()
    reader.onload = () => {
      if (reader.result instanceof ArrayBuffer)
        resolve(new Uint8Array(reader.result))
      else reject(new Error("The file could not be read"))
    }
    reader.onerror = () => reject(reader.error)
    reader.readAsArrayBuffer(blob)
  })
}

const parse = (bytes: Uint8Array): unknown => {
  try {
    return JSON.parse(new TextDecoder().decode(bytes))
  } catch {
    return null
  }
}

export const jsonBody = async (data: unknown): Promise<unknown> => {
  // Not instanceof: a buffer from another realm (an iframe, jsdom) fails it.
  if (Object.prototype.toString.call(data) === "[object ArrayBuffer]")
    return parse(new Uint8Array(data as ArrayBuffer))
  // The type may carry parameters, as in "application/json; charset=utf-8".
  if (!(data instanceof Blob) || !data.type.startsWith("application/json"))
    return data
  return parse(await bytesOf(data))
}
